import { addOnClosestListener } from '../general/helpers';

export default function collectionSimpleFiltersController() {
  function toggleFilter(filter) {
    const isOpened = filter.parentElement.classList.contains('active');

    filter
      .closest('.main-collection-simple-filters')
      ?.querySelectorAll('.main-collection-simple-filter, .main-collection-simple-filter__items')
      ?.forEach((el) => {
        el.classList.remove('active');
      });

    const index = filter.getAttribute('data-index');

    filter.parentElement.classList.toggle('active', !isOpened);
    filter
      .closest('.main-collection-simple-filters')
      ?.querySelector(`.main-collection-simple-filter__items[data-index="${index}"]`)
      ?.classList.toggle('active', !isOpened);
  }

  addOnClosestListener('click', '.main-collection-simple-filter__title', (element) => {
    toggleFilter(element);
  });

  addOnClosestListener('keydown', '.main-collection-simple-filter__title', (element, event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleFilter(element);
      event.preventDefault();
    }
  });
}
